import { router } from 'expo-router'
import type { ReactNode } from 'react'
import { View } from 'react-native'

import { INTENTION_TYPE } from '@/src/features/intention/models/Intention.enums'
import { useIntentionQuery } from '@/src/features/intention/services/useIntentionQuery'
import { IntentionPray } from '@/src/features/intention/ui/components/IntentionPray'
import type { TCommunityJoinParams } from '@/src/general/constants/routes'
import { TEST_ID } from '@/src/general/constants/testId'
import { ErrorScreen } from '@/src/general/ui/screens/ErrorScreen'
import { TRACKING_SOURCE } from '@/src/general/utils/gtm/constants'
import { parseIdDash } from '@/src/general/utils/parseIdDash'
import { useRoutes } from '@/src/general/utils/routes'

type TPublicationRewardPrayScreenProps = TIdSlugParam &
  TCommunityJoinParams & {
    intentionIdToken: TIdDashSlug
  }

export const CommunityJoinNextIntentionsPrayScreen = ({
  idSlug,
  course,
  origin,
  source,
  intentionIdToken,
}: TPublicationRewardPrayScreenProps): ReactNode => {
  const [id, slug] = parseIdDash(idSlug)
  const [intentionId, shareToken] = parseIdDash(intentionIdToken)

  const { routes } = useRoutes()
  const { intention, isSuccess, error } = useIntentionQuery(intentionId, shareToken, INTENTION_TYPE.INTENTION)

  const navigateBack = () => router.navigate(routes.communityJoinNext({ id, slug, course, origin, source }))

  if (error || (isSuccess && !intention)) {
    return (
      <ErrorScreen
        buttons={[{ onPress: navigateBack }]}
        error={error}
        defaultErrorKey="intention.load.error"
        testID={TEST_ID.PRAY.SCREEN.ERROR}
      />
    )
  }

  return (
    <View testID={TEST_ID.COMMUNITY.JOIN_NEXT_INTENTION_PRAY_SCREEN} className="flex-1">
      <IntentionPray
        type={INTENTION_TYPE.INTENTION}
        trackingSource={TRACKING_SOURCE.COMMUNITY_JOIN}
        intention={intention}
        onAmen={navigateBack}
        onClose={navigateBack}
      />
    </View>
  )
}
